import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import Testimonial from "../components/Testimonial";
import Process from "../components/Process";
import Footer from "../components/Footer";

function Home() {
    return (
<main>
    <Navbar/>
    <Hero/>
    <Stats/>
    <Process/>
    <Testimonial/>
    <Footer/>
</main>
);
}

export default Home;